import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link } from "react-router-dom"
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"
import { FaEuroSign, FaIdCardClip, FaInstagram, FaMobileScreen, FaUser } from "react-icons/fa6"
import {
  MdContactPage,
  MdGroup,
  MdLibraryBooks,
  MdLocalActivity,
  MdOutlinePayments,
  MdPriceChange,
  MdReport,
  MdSettings,
  MdWorkOutline,
} from "react-icons/md"
import { LuFileSpreadsheet, LuSun } from "react-icons/lu";
import { FaBell, FaCalendarAlt, FaDumbbell, FaHome, FaPoundSign, FaQuestion } from "react-icons/fa"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [setting, setSetting] = useState(false)
  const [expense, setExpense] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav ps-1 pe-0" style={{ zIndex: "1001" }}>
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}dashboard`}
                    >
                      <FaHome className="me-2 fs-5" />
                      {"Dashboard"} {props.menuOpen}
                    </Link>
                    {/* <div
                      className={classname("dropdown-menu", { show: dashboard })}
                    >
                    </div> */}
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}calendar`}
                    >
                      <FaCalendarAlt  className="me-2 fs-5" />
                      {"Calendar"} {props.menuOpen}
                    </Link>
                    {/* <div
                      className={classname("dropdown-menu", { show: dashboard })}
                    >
                    </div> */}
                  </li>

                  <li className="nav-item dropdown">
                    <a className="btn nav-link dropdown-toggle arrow-none text-dark">
                      <LuSun className="me-2 fs-5" />
                      {"Season"} {props.menuOpen}
                    </a>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        className="dropdown-item"
                        to={`${Configs.appurl}clubs`}
                      >
                        {"Club Management"} {props.menuOpen}
                      </Link>
                      <Link
                        className="dropdown-item"
                        to={`${Configs.appurl}seasons`}
                      >
                        {"Season Management"} {props.menuOpen}
                      </Link>
                      <Link
                        className="dropdown-item"
                        to={`${Configs.appurl}league`}
                      >
                        {"League Management"} {props.menuOpen}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}users`}
                    >
                      <MdGroup className="me-2 fs-5" />
                      {"Users"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}activities`}
                    >
                      <GrPlan className="me-2 fs-5" />
                      {"Activities"} {props.menuOpen}
                    </Link>
                  </li> */}

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}payments`}
                    >
                      <FaPoundSign className="me-2 fs-5" />
                      {"Payments"} {props.menuOpen}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}workouts`}
                    >
                      <FaDumbbell className="me-2 fs-5" />
                      {"Workouts"} {props.menuOpen}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}library`}
                    >
                      <FaMobileScreen className="me-2 fs-5" />
                      {"Library"} {props.menuOpen}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}user-plan`}
                    >
                      <FaIdCardClip className="me-2 fs-5" />
                      {"User Plan"} {props.menuOpen}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}user-query`}
                    >
                      <FaQuestion className="me-2 fs-5" />
                      {"User Query"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* sales */}
                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none text-dark">
                      <LuFileSpreadsheet className="me-2 fs-5" />
                      {"Reports"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}plan-history`}
                        className="dropdown-item"
                      >
                        Plan History
                      </Link>
                      <Link
                        to={`${Configs.appurl}activity-report`}
                        className="dropdown-item"
                      >
                        Activity Report
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${Configs.appurl}activity-overview`}
                    >
                      <FaBell className="me-2 fs-5" />
                      {"Notifications"} {props.menuOpen}
                    </Link>
                  </li>
                </div>
              </ul>
              <Dropdown>
                <DropdownToggle nav caret className="text-dark">
                  <MdSettings className="me-2 fs-5" />
                  Settings
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>
                    <Link
                      to={`${Configs.appurl}social-media`}
                      className="text-dark"
                    >
                      <FaInstagram className="me-2 fs-5" /> Social Media
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default Navbar
